/* import __COLOCATED_TEMPLATE__ from './billing-cycle-metrics.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();